import React from 'react';
import { AnimatePresence } from 'framer-motion';

import Lines from '@svg/filters.svg';
import Search from '@svg/search.svg';
import { useFilters } from '@lib/context';
import { MobileSearch } from './mobileSearch';
import { FiltersInner } from './filtersInner';

export const MobileFilters = ({
  searchOpen,
  setSearchOpen,
  filtersOpen,
  setFiltersOpen,
  setStep,
  media,
  artists,
  venues,
}) => {
  const { updateBlogLabel } = useFilters();

  return (
    <>
      <div className='flex gap-x-4 pb-10 relative z-20 lg:hidden nav-blur justify-center'>
        {media ? (
          <select
            onChange={(e) =>
              updateBlogLabel(e.target.value === 'all' ? false : e.target.value)
            }
            className='border-0 focus:ring-0 focus:border-0 flex gap-x-4 items-center btn-standard bg-teal bg-opacity-10 text-teal !pr-10'>
            <option selected value={'all'}>
              All
            </option>
            {media.map(({ title }, i) => (
              <option key={i} value={title}>
                {title}
              </option>
            ))}
          </select>
        ) : (
          <button
            onClick={() => setFiltersOpen(true)}
            className='flex gap-x-4 items-center btn-standard bg-teal bg-opacity-10 text-teal'>
            <Lines className='w-4' />
            <span>Filter</span>
          </button>
        )}
        <button
          onClick={() => setSearchOpen(true)}
          className='flex gap-x-4 items-center btn-standard bg-teal bg-opacity-10 text-teal'>
          <Search className='w-4' />
          <span>Search</span>
        </button>
      </div>

      <FiltersInner
        setFiltersOpen={setFiltersOpen}
        filtersOpen={filtersOpen}
        setStep={setStep}
        artists={artists}
        venues={venues}
      />
      <MobileSearch setSearchOpen={setSearchOpen} searchOpen={searchOpen} />
    </>
  );
};
